export default {
	init: false,
	enabled: true,
	autoreply: null,
	name: 'Loading ...',
	openHours: {
		Montag: [],
		Dienstag: [],
		Mittwoch: [],
		Donnerstag: [],
		Freitag: [],
		Samstag: [],
		Sonntag: [],
	},
	questions: {
		tradein: null,
		financing: null,
		instalment: null,
	},
};
